/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_Search_ErrorInputs */

const es_tools_drive_search_error = /** @type {(inputs: Tools_Drive_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al buscar en Drive`)
};

const en_tools_drive_search_error = /** @type {(inputs: Tools_Drive_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error searching Drive`)
};

/**
* | output |
* | --- |
* | "Error searching Drive" |
*
* @param {Tools_Drive_Search_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_search_error = /** @type {((inputs?: Tools_Drive_Search_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_Search_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_search_error(inputs)
	return en_tools_drive_search_error(inputs)
});
export { tools_drive_search_error as "tools.drive.search_error" }